import { appURLs } from "@/app/constants.mjs";

export const LINKED_ACCOUNT_EMPTY_STATE_ROBOT = `${appURLs.CDN_VIDEOS}/ui/video/linked-account-robot-400x400.webm`;

export const DELETE_USER = "deleteUserSetting";
export const EDIT_INFO = "editUserSettings";
export const EDIT_EMAIL = "editEmailSettings";
export const SNACKBAR_ID = "savedSettings";
